import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a number as Euro currency (symbol on the right, European format)
 * @param value - The numeric value to format
 * @param showDecimals - Whether to show decimal places (default: true)
 */
export function formatEuro(value: number | string | null | undefined, showDecimals: boolean = true, locale: string = "es-ES"): string {
  const num = Number(value ?? 0);
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(Number.isFinite(num) ? num : 0);
  return locale === "en-US" ? `€${formatted}` : `${formatted} €`;
}

/**
 * Format a number as Euro for display in charts (compact format)
 * @param value - The numeric value to format
 */
export function formatEuroCompact(value: number | string | null | undefined, locale: string = "es-ES"): string {
  const num = Number(value ?? 0);
  const safeNum = Number.isFinite(num) ? num : 0;
  
  if (safeNum >= 1000000) {
    return `${(safeNum / 1000000).toFixed(1)}M €`;
  }
  if (safeNum >= 1000) {
    return `${(safeNum / 1000).toFixed(0)}k €`;
  }
  return locale === "en-US" ? `€${safeNum}` : `${safeNum} €`;
}
